import React from "react";
import { useNavigate } from 'react-router-dom';

import imageOne from "../../resource/meditate/ordination/2.png";
import imageFour from "../../resource/meditate/ordination/3.png";
import imageFive from "../../resource/meditate/ordination/4.png";

import imageThree from "../../resource/meditate/guest-speaker/1.png";
import TitleChnage from "../../Hook/TitleChnage";

import imageone from "../../resource/meditate/ordination/6.jpeg";
import imagetwo from "../../resource/meditate/ordination/7.jpeg";

const Ordination = () => {
  TitleChnage("Ordination");

   const navigate = useNavigate();
  
      const handleClick = (event) => {
  
          const pathMap = {
            ordinationRequest : '/ordinationRequest',
           ordinationRegistration : '/ordinationRegistration'
  
          }
      
          const path = event.currentTarget.id;
          const targetPath = pathMap[path]
      
          if (targetPath){
            navigate(targetPath)
          }
        }
  return (
    <div className="ordination-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main dark-gold p-4 mt-4">Ordination</h1>

      <p className="mt-5 h4 p-4">
        "pabbajja bikkhāwe pandita paññāththan sathpurusha paññāththan"{" "}
      </p>
      <p className="mt-4 h4 p-4">Anguttara Nikaya</p>

      <p className="mt-5 h4 p-4">
        The life of a Samana represents a significant act of renunciation,
        providing a refuge from the turbulence of the world and a path toward
        freedom through simplicity and humility. This path leads to a state of
        blissful calmness, peace, and profound wisdom. The Buddha's Sasana, or
        dispensation, is rooted in the contemplative path of the Samana life,
        offering a way of living for those who seek deep spiritual peace and
        profound insight.
      </p>
      <p className="mt-5 h4 p-4">
        Samanas voluntarily relinquish the comforts and attachments of worldly
        life, embracing simplicity, contentment, and humility in their pursuit
        of liberation. By studying and practicing the profound teachings of the
        Buddha, adhering to ethical conduct (Vinaya), and meditating to gain
        wisdom, Samanas experience ease and fulfillment. The Samana life is an
        inward journey— a quest to uncover the true nature of existence.
      </p>
      <p className="mt-5 h4 p-4">
        Even if the ultimate goal of Nibbāna is not fully attained, living as a
        Samana bestows numerous blessings. Being part of a humble and contented
        Sangha community provides practical experience of the Buddha's teachings
        and fosters a deep sense of gratitude for life and all its surroundings.
      </p>
      <p className="mt-5 h4 p-4">
        Bhaddeka Vihari Monastery invites suitable candidates for training and
        ordination, guiding them through a gradual process of renunciation and
        virtuous living for spiritual development and inner peace. It is a
        blessing to the Sri Lankan Buddhist community to have opportunities to
        embrace the Samana life in a well-established Monastery, rich in the
        qualities of the traditional forest Sangha.
      </p>


      <img src={imageone} className="mt-6" alt="" style={{ width: "100%" }} />



      <h1 className="font-second dark-gold p-4 mt-6">Long Term Ordination</h1>


      <p className="mt-5 h4 p-4">
        Bhaddeka Vihari Monastery offers a valuable opportunity for long-term
        ordination, thereby supporting the Sasana, giving the benefit to the
        Buddhist community. The monastery provides essential training to
        understand Buddhist philosophy and assists in practicing according to
        the teachings.
      </p>
      <p className="mt-5 h4 p-4">
      To maintain a conducive atmosphere for physical and mental health, thereby ensuring uninterrupted and meaningful practice, the following guidelines are in place:
      </p>
      <ul className="p-4 ordination-list h4 mt-4">
        <li>Candidates should be between 18 to 60 years of age</li>
        <li>Candidates should have a sound educational background.</li>
        <li>Candidates should possess a good sense of humor.</li>
        <li>Candidates should not have any disabilities.</li>
        <li>Candidates must have permission from their parents or guardians.</li>
        <li>Candidates should have no financial obligations</li>
        <li>Candidates should have no legal bindings</li>
        <li>Candidates who worked in military service should be retired.</li>
      </ul>

      <img src={imagetwo} className="mt-6" alt="" style={{ width: "100%" }} />


      <h1 className="font-second dark-gold p-4 mt-6">Short Term Ordination</h1>

    

      <p className="mt-5 h4 p-4">
      For those wishing to experience the Samana life on a temporary basis, Bhaddeka Vihari Monastery offers an opportunity for short-term ordination. To ensure a beneficial outcome from this commitment, the following guidelines apply:
      </p>
      <ul className="p-4 ordination-list h4 mt-4">
        <li>
        Candidates must undergo a short probation period to familiarize themselves with the Sangha community and the monastery's way of life.
        </li>
        <li>
        Candidates must commit to staying in the robes for a minimum of three months.
        </li>
      </ul>
      <p className="mt-5 h4 p-4">
        By following these guidelines, candidates can embark on a meaningful
        journey towards spiritual development, experiencing the profound peace
        and wisdom of the Samana life.
      </p>

      <div className="btn-group mt-6">
        <img src={imageFour} alt="Right Top Image" width={300}  onClick={handleClick} id="ordinationRegistration" className="curser-pointer"/>
      </div>

    


      <div className="mt-6 calander-box align-item-center p-4 text-center">
                    <div className="c-details text-left">
                        <h2 className='intro-text '>Contact Details</h2>
                        <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                        <p className="font-p">Mr Gamini : 0422 069 359</p>
                        <p className="font-p">WhatsApp : 0422 069 359</p>
                        <p className="font-p">E-mail : info@bvp.org.au</p>
                    </div>

                <div className="bottom-box mt-6">
        <img src={imageFive} alt="bottom-image"  width={300} onClick={handleClick} id="ordinationRequest" className="curser-pointer"/>
    </div>
                </div>


        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>
    </div>
  );
};

export default Ordination;
